import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CFormFeedback, CFormLabel, CPopover } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';

import { getHTMLFromDraft, getEditorStateFromHTML, toastError } from '../../../utils';
import { DEFAULT_FN, EDITOR_OPTIONS } from '../../../constants';
import { callApi } from '../../../apiCaller';

const uploadImageCallBack = (file) => {
     return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = async () => {
               try {
                    const formDataUploadFile = new FormData();
                    formDataUploadFile.append('file', file);
                    const response = await callApi(`media`, 'POST', formDataUploadFile);

                    if (response.status !== 200) {
                         toastError(response);
                         reject(response);
                         return;
                    }

                    const link = response.data.file.location;
                    resolve({ data: { link } });
               } catch (error) {
                    toastError(error);
                    reject(error);
               }
          };

          reader.onerror = (error) => {
               reject(error);
          };
          reader.readAsDataURL(file);
     });
};

const WysiwygEditorGroup = ({ id, label, isRequired, value, error, disabled, tooltip, updateError, options, setFieldValue }) => {
     const onEditorStateChange = (e) => {
          const htmlFromDraft = getHTMLFromDraft(e);

          setFieldValue(
               id,
               htmlFromDraft.replace('<p></p>\n', '').replace(/(<img[^>]*>)/g, (imgTag) => `<div style="text-align:center;">${imgTag}</div>`)
          );
          updateError(id);
     };

     const wrapperClassName = classNames('draft-editor-wrapper', { 'is-invalid': isRequired && !!error });

     return (
          <div className="form-group">
               <CFormLabel htmlFor={id}>
                    {label}
                    {tooltip && (
                         <CPopover content={tooltip} placement="top" trigger="hover">
                              <CIcon icon="icon-info-cilcle" />
                         </CPopover>
                    )}
                    {isRequired && <span className="text-danger">*</span>}
               </CFormLabel>
               <Editor
                    defaultEditorState={getEditorStateFromHTML(value)}
                    wrapperClassName={wrapperClassName}
                    editorClassName="draft-editor-main"
                    onEditorStateChange={onEditorStateChange}
                    toolbar={{
                         options: options,
                         link: {
                              inDropdown: true,
                              showOpenOptionOnHover: false,
                         },
                         image: {
                              uploadEnabled: true,
                              uploadCallback: uploadImageCallBack,
                              previewImage: true,
                              alt: { present: true, mandatory: false },
                              inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                              alignmentEnabled: false,
                         },
                    }}
                    readOnly={disabled}
                    handlePastedText={() => false}
               />

               {isRequired && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

WysiwygEditorGroup.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     isRequired: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     disabled: PropTypes.bool,
     tooltip: PropTypes.string,
     updateError: PropTypes.func,
     setFieldValue: PropTypes.func,
};

WysiwygEditorGroup.defaultProps = {
     options: EDITOR_OPTIONS,
     updateError: DEFAULT_FN,
     setFieldValue: DEFAULT_FN,
};

export default WysiwygEditorGroup;
